import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';
import {
  dynamicSnapshotToggleHints,
  dynamicSnapshotToggleLabels,
  type DynamicSectionDataMode,
} from './dynamicSectionSnapshot';
import { SnapshotModeInfo } from './SnapshotModeInfo';

type DynamicSectionDataToggleProps = {
  approvalStatus?: string | null;
  mode: DynamicSectionDataMode;
  onModeChange: (mode: DynamicSectionDataMode) => void;
  disabled?: boolean;
};

export default function DynamicSectionDataToggle({
  approvalStatus,
  mode,
  onModeChange,
  disabled = false,
}: DynamicSectionDataToggleProps) {
  const labels = dynamicSnapshotToggleLabels(approvalStatus);
  const hints = dynamicSnapshotToggleHints(approvalStatus);
  return (
    <ToggleGroup
      multiple={false}
      size="sm"
      variant="outline"
      spacing={0}
      value={[mode]}
      disabled={disabled}
      onValueChange={(next) => {
        const value = Array.isArray(next) ? next[0] : next;
        if (value === 'snapshot' || value === 'live') {
          onModeChange(value);
        }
      }}
      aria-label="Section data source"
    >
      <ToggleGroupItem value="snapshot">
        <SnapshotModeInfo label={labels.snapshot} hint={hints.snapshot} />
      </ToggleGroupItem>
      <ToggleGroupItem value="live">
        <SnapshotModeInfo label={labels.live} hint={hints.live} />
      </ToggleGroupItem>
    </ToggleGroup>
  );
}
